import mappingConstants from './MappingConstants';
import {
  backupTargetFieldsSuccess,
  restoreTargetFieldsSuccess
} from '../targetFields/TargetFieldsActions';

const fetchImportMappingDataSuccess = mappingInfo => ({
  type: mappingConstants.FETCH_IMPORT_MAPPING_DATA_SUCCESS,
  mappingInfo
});
const updateContainerList = containers => ({
  type: mappingConstants.UPDATE_CONTAINER_LIST,
  containers
});
const resetImportMappingDataSuccess = fileExtension => ({
  type: mappingConstants.RESET_IMPORT_MAPPING_DATA_SUCCESS,
  fileExtension
});
const setMappedFieldsSuccess = (
  sourceField,
  targetField,
  subGroup,
  prevValue,
  activeDivision
) => ({
  type: mappingConstants.SET_MAPPED_FIELD,
  sourceField,
  targetField,
  subGroup,
  prevValue,
  activeDivision
});
const setActiveDivisionSuccess = division => ({
  type: mappingConstants.SET_ACTIVE_DIVISION,
  division
});
const backupMappedFieldsSuccess = () => ({
  type: mappingConstants.BACKUP_MAPPED_FIELDS
});
const restoreMappedFieldsSuccess = () => ({
  type: mappingConstants.RESTORE_MAPPED_FIELDS
});
const resetMappedFieldsInDivision = division => ({
  type: mappingConstants.RESET_MAPPED_FIELDS_IN_DIVISION,
  division
});
const addDivisionMapToMapping = division => ({
  type: mappingConstants.ADD_DIVISION_MAP_TO_MAPPING,
  division
});
const loadMappedFieldsInDivision = division => ({
  type: mappingConstants.LOADED_MAPPED_FIELDS_DIVISION,
  division
});
const loadMappedFields = () => ({
  type: mappingConstants.LOADED_MAPPED_FIELDS
});

const resetImportMappingData = fileExtension => dispatch =>
  dispatch(resetImportMappingDataSuccess(fileExtension));
const setActiveDivision = division => dispatch =>
  dispatch(setActiveDivisionSuccess(division));
const backupMappedFields = () => dispatch => {
  dispatch(backupMappedFieldsSuccess());
  dispatch(backupTargetFieldsSuccess());
};
const restoreMappedFields = () => dispatch => {
  dispatch(restoreMappedFieldsSuccess());
  dispatch(restoreTargetFieldsSuccess());
};

const setMappedFields = (
  sourceField,
  targetField,
  subGroup,
  prevValue,
  activeDivision
) => dispatch => {
  dispatch(
    setMappedFieldsSuccess(
      sourceField,
      targetField,
      subGroup,
      prevValue,
      activeDivision
    )
  );
};

export {
  fetchImportMappingDataSuccess,
  resetImportMappingDataSuccess,
  resetImportMappingData,
  updateContainerList,
  setMappedFields,
  setActiveDivision,
  backupMappedFields,
  restoreMappedFields,
  resetMappedFieldsInDivision,
  loadMappedFields,
  loadMappedFieldsInDivision,
  addDivisionMapToMapping
};



// WEBPACK FOOTER //
// ./src/redux/mapping/MappingActions.js